module.exports = __webpack_public_path__ + "media/buy_report_icons/documents-297282a0.svg";